/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Disable cloud variables",
  "description": "Disable cloud variables by default. You can still re-enable them using the Edit > Enable cloud variables menu.",
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "tags": [
    "danger"
  ],
  "enabledByDefault": false
};
import {isScratchDesktop} from "../../../lib/isScratchDesktop";
if (isScratchDesktop()) manifest.unsupported = true;
export default manifest;
